export const headers = [
  { text: 'Terminal name', value: 'terminal', sortable: false },
  { text: 'Pictures (#)', value: 'totalPictures', width: '120px', align: 'right', sortable: false },
  { text: 'Cash ($)', value: 'totalCash', width: '100px', align: 'right', sortable: false },
  { text: 'Card ($)', value: 'totalCard', width: '100px', align: 'right', sortable: false },
  { text: 'Tax ($)', value: 'totalTax', width: '100px', align: 'right', sortable: false },
  { text: 'Total ($)', value: 'totalMoney', width: '100px', align: 'right', sortable: false },
]